import { render, staticRenderFns } from "./QuitaShow.vue?vue&type=template&id=5e63f519"
import script from "./QuitaShow.vue?vue&type=script&lang=js"
export * from "./QuitaShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports